export const isFieldEmptyValidation = (
  value: string,
  validationMessage: string
) => {
  if (value.length <= 0) {
    return validationMessage;
  }

  return '';
};
